module.exports = __webpack_public_path__ + "img/logolandscape.34f9c9ea.png";